import httpClient from "../http/http-client";
import { ICustomField, IPostCustomField } from './custom-field.model';

export default class CustomFieldService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<ICustomField[]> {
    return this.http.get(`custom-field${queryString ? queryString : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: ICustomField[] }> {
    return this.http.get(`custom-field?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  /** Materialise the curated product passport attribute set for the caller's organisation. Idempotent. */
  async seedPassportTemplate(): Promise<{ created: string[], existing: string[] }> {
    return this.http.post(`custom-field/passport-template`, {})
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllActive(queryString?: string): Promise<ICustomField[]> {
    return this.http.get(`custom-field?active=true${queryString ? queryString : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }



  async getOne(customFieldId: string): Promise<ICustomField> {
    return this.http.get(`custom-field/${customFieldId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(customField: IPostCustomField): Promise<ICustomField> {
    return this.http.post(`custom-field`, customField)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async update(customFieldId: string, customField: IPostCustomField): Promise<ICustomField> {
    return this.http.patch(`custom-field/${customFieldId}`, customField)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async updateDisplayMode(customFieldId: string, displayMode: 'mandatory' | 'optional' | 'hidden'): Promise<ICustomField> {
    return this.http.patch(`custom-field/${customFieldId}`, { displayMode })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async changeActiveStatus(customFieldId: string, active: boolean): Promise<ICustomField> {
    return this.http.post(`custom-field/status/${customFieldId}`, { active })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async remove(customFieldId: string): Promise<ICustomField> {
    return this.http.delete(`custom-field/${customFieldId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}